import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        chartList: [],
		pager: {},
        loading: false,
		dashboard: {},
		pkrange: [],
		exrange: [],
		siteDashboard: {}
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获取四个数据列表的数据
		async getGeneral({ commit }: any) {
			const res = await fetch({
				url: '/admin/dashboard/general'
			})
            commit('setState',{key:'dashboard',data: res})
            
        },
        // 获取图标数据
		async getInventory({ commit }: any, params: any) {
            commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/dashboard/inventory',
                params
			})
            commit('setState',{key:'chartList',data: res.chart})
			commit('setState', { key: 'pkrange', data: res.pkrange})
			commit('setState', { key: 'exrange', data: res.exrange })
            commit('setState',{key:'loading',data: false})
		},
		// 获取数据监控派件数据
		async getAssignData({ commit }: any, params: any){
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
                url: '/admin/analyze/packages',
                params
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 获取数据监控寄件数据
		async getDeliveryData({ commit }: any, params: any){
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
                url: '/admin/analyze/delivery',
                params
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 获取数据监控寄件和派件的图标数据
		async getVeLineData({ commit }: any, params: any){
			return await fetch({
                url: '/admin/analyze/chart',
                params
			})
		},
		// 获取四个数据列表的数据
		async getSiteGeneral({ commit }: any,params: any) {
			const res = await fetch({
				url: `/admin/analyze/general`,
				params
			})
            commit('setState',{key:'siteDashboard',data: res})
        },
	}
}